/**
 * Item Search Vuex module for Portal Application
 * Controls the data and actions for the Item Search Inquiry
 * 
 * @module ItemSearch
 * @see
 * @author Bailey Kulman (Fresche Solutions)
 * @date August 2023
 */

import portalapi from "@services/portalapi";
import { resetStateData } from "@/utils/vuexStoreUtils";
import { getField, updateField } from "vuex-map-fields";

const DEFAULT_STATE = {
    searchItems: [],
};

const state = structuredClone(DEFAULT_STATE);

const getters = {
    getField, // for vuex-map-fields

    getSearchItems(st) {
        return st.searchItems;
    },
};

const mutations = {
    updateField, // for vuex-map-fields

    async clearStateData(st) {
        st = resetStateData(st, DEFAULT_STATE);
    },

    setSearchItems(st, payload) {
        st.searchItems = payload;
    },
};

const actions = {

    // Get Search Items
    async fetchSearchItems({ commit }, payload) 
    {
        const requestPayload = {
            page: (payload && payload.page ? payload.page : 1),
            itemsPerPage: (payload && payload.itemsPerPage ? payload.itemsPerPage : 20),
            filters: (payload && payload.filters ? payload.filters : []),
            sortBy: (payload && payload.sortBy ? payload.sortBy : {column: "itemNumber", state: 0}),
        };

        const response = await portalapi.moduleCatalogs.getSearchItems(requestPayload);

        if (response.status === vm.config.globalProperties.$constants.HTTP_STATUS_CODES.OK) {
            commit("setSearchItems", response.data);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
